/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
/**
 * MarketCapApi - axios parameter creator
 * @export
 */
export const MarketCapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get the status of the market cap collector Lambda function, including whether it\'s currently running. Only accessible by admin users.
         * @summary Get Lambda status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLambdaStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/market-cap/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all market cap data from S3, including file timestamp to determine data freshness. Only accessible by admin users.
         * @summary Get market cap data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketCapData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/market-cap/data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Trigger the Lambda function to collect and update market cap data from Finnhub API. Only accessible by admin users.
         * @summary Trigger market cap update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerMarketCapUpdate: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/market-cap/trigger`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketCapApi - functional programming interface
 * @export
 */
export const MarketCapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketCapApiAxiosParamCreator(configuration)
    return {
        /**
         * Get the status of the market cap collector Lambda function, including whether it\'s currently running. Only accessible by admin users.
         * @summary Get Lambda status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLambdaStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLambdaStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketCapApi.getLambdaStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all market cap data from S3, including file timestamp to determine data freshness. Only accessible by admin users.
         * @summary Get market cap data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMarketCapData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMarketCapData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketCapApi.getMarketCapData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Trigger the Lambda function to collect and update market cap data from Finnhub API. Only accessible by admin users.
         * @summary Trigger market cap update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async triggerMarketCapUpdate(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.triggerMarketCapUpdate(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketCapApi.triggerMarketCapUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MarketCapApi - factory interface
 * @export
 */
export const MarketCapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketCapApiFp(configuration)
    return {
        /**
         * Get the status of the market cap collector Lambda function, including whether it\'s currently running. Only accessible by admin users.
         * @summary Get Lambda status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLambdaStatus(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getLambdaStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Read all market cap data from S3, including file timestamp to determine data freshness. Only accessible by admin users.
         * @summary Get market cap data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMarketCapData(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.getMarketCapData(options).then((request) => request(axios, basePath));
        },
        /**
         * Trigger the Lambda function to collect and update market cap data from Finnhub API. Only accessible by admin users.
         * @summary Trigger market cap update
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        triggerMarketCapUpdate(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.triggerMarketCapUpdate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketCapApi - object-oriented interface
 * @export
 * @class MarketCapApi
 * @extends {BaseAPI}
 */
export class MarketCapApi extends BaseAPI {
    /**
     * Get the status of the market cap collector Lambda function, including whether it\'s currently running. Only accessible by admin users.
     * @summary Get Lambda status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketCapApi
     */
    public getLambdaStatus(options?: RawAxiosRequestConfig) {
        return MarketCapApiFp(this.configuration).getLambdaStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all market cap data from S3, including file timestamp to determine data freshness. Only accessible by admin users.
     * @summary Get market cap data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketCapApi
     */
    public getMarketCapData(options?: RawAxiosRequestConfig) {
        return MarketCapApiFp(this.configuration).getMarketCapData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Trigger the Lambda function to collect and update market cap data from Finnhub API. Only accessible by admin users.
     * @summary Trigger market cap update
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketCapApi
     */
    public triggerMarketCapUpdate(options?: RawAxiosRequestConfig) {
        return MarketCapApiFp(this.configuration).triggerMarketCapUpdate(options).then((request) => request(this.axios, this.basePath));
    }
}

